export enum AttributeSize {
	Extralong = "EXTRALONG",
	Long = "LONG",
	Medium = "MEDIUM",
	Short = "SHORT",
}
